import { render } from "./section-table.vue?vue&type=template&id=43a08be9&scoped=true"
import script from "./section-table.vue?vue&type=script&lang=js"
export * from "./section-table.vue?vue&type=script&lang=js"

import "@/assets/scss/retail/section-search-select.scss?vue&type=style&index=0&id=43a08be9&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a08be9"]])

export default __exports__